import * as React from "react";
import Modal from "../../misc/components/modal";
import { AuditModalBody } from "../../auditmodal/components/AuditModalBody";
import { CommentsSelector } from "../../misc/components/CommentsSelector";
import { SessionFixedCommentState, ToggleSessionFixedCommentCheckedAction } from "./UseFixedComments";
import { TestFixedCommentsError } from "./TestFixedCommentsError";
import { OverreadStatusIdEnum } from "../../misc/api/apiTypes";

export enum AcceptabilityValidationWizardState {
    TestFixedComments = 'testFixedComments',
    SessionFixedComments = 'sessionFixedComments',
    Audit = 'audit',
}

export interface AcceptabilityValidationWizard {
    visibleStep: AcceptabilityValidationWizardState;
    isSubmitting: boolean;
    sessionFixedComments: SessionFixedCommentState;
    rejectedTestsMissingComments: number[];
    overreadStatus: string;
    onCancel: () => void;
    onFixedCommentSelected: () => void;
    onSubmit: (annotation: string) => void;
    dispatch: React.Dispatch<any>;
}

export const AcceptabilityValidationWizard = ({ visibleStep, isSubmitting, sessionFixedComments, rejectedTestsMissingComments, overreadStatus, onCancel, onSubmit, onFixedCommentSelected, dispatch }: AcceptabilityValidationWizard) => {

    if ((overreadStatus == OverreadStatusIdEnum.NotStarted || overreadStatus == OverreadStatusIdEnum.Pending) && visibleStep == AcceptabilityValidationWizardState.Audit) {
        onSubmit(null);
        return null;
    }
    const getPage = () => {
        switch (visibleStep) {
            case AcceptabilityValidationWizardState.Audit:
                return (<AuditModalBody
                    isSubmitting={isSubmitting}
                    onClose={() => onCancel()}
                    onSubmit={(auditForm) => onSubmit(auditForm.Annotation)}
                >
                </AuditModalBody>);
            case AcceptabilityValidationWizardState.TestFixedComments:
                return (<TestFixedCommentsError
                    testsMissingComments={rejectedTestsMissingComments}
                    onOk={() => onCancel()}
                />);
            case AcceptabilityValidationWizardState.SessionFixedComments:
                return <CommentsSelector
                    onOk={() => onFixedCommentSelected()}
                    editable={true}
                    errorMessage={sessionFixedComments.comments.filter(x => x.selected).length === 0 ? "A session comment is required" : null}
                    items={sessionFixedComments.comments}
                    onChange={(id, checked) => dispatch(ToggleSessionFixedCommentCheckedAction.create(id, checked))}
                />
        }

    }

    return  (
        <Modal show={true} closeModalHandler={() => onCancel()} header="Session Approval">
            {getPage()}
        </Modal>
    );
}
